<template>
  <el-dropdown-item :disabled="row.securityFuncFlag === 1"
                    @click.native="toggleSecurity">
    {{ title }}
  </el-dropdown-item>
</template>

<script>
import Hundun from '@/service/hundun'
export default {
  name: 'security-action-drop-item',
  props: {
    row: { type: Object, required: true },
    value: { type: Boolean, default: false }
  },
  computed: {
    title ({ row }) {
      return row.securityFuncFlag === 4 ? '取消防伪码功能' : '开启防伪码功能'
    },
    loading: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    toggleSecurity () {
      this.$confirm(`是否${this.title}?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.loading = true
          const { securityFuncFlag, tagSegDetailsId } = this.row
          const methods = securityFuncFlag === 4 ? 'canclesecurityfunc' : 'opensecurityfunc'
          Hundun[methods]({ tagSegDetailsId })
            .then(res => {
              const { result, message } = res.data
              this.loading = false
              if ([0].includes(result)) {
                this.$message.success(this.title + '成功')
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error(err.message)
            })
        })
    }
  }
}
</script>
